export enum BetType {
  'Winner' = 1,
  'Place (2)' = 2,
  'Place (3)' = 3,
  'Place (4)' = 4,
  'Place (5)' = 5,
  'Place (6)' = 6,
  'Quinella' = 7,
  'Exacta' = 8,
  'Tricast any order' = 9,
  'Tricast' = 10,
  'Head to Head'= 11,
  'Even And Odd' = 12,
  'Under Over' = 13,
  'ShortM (x)' = 14,
  'Lenghts (x)' = 16,
  'Dispersion (x)' = 18,
  'NotPlace (2)' = 22,
  'NotPlace (3)' = 23,
  'NotPlace (4)' = 24,
}
